import {
  Box,
  Button,
  Divider,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { ButtonGroupFilter } from "@roc/feature-comp-tool";
import { roomsOptions } from "../../types/filtersOptions";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "400px"
  },
  applyButton: {
    width: "300px"
  }
}));

interface BedsAndBathsFiltersProps {
  onApply: () => void;
}

export const BedsAndBathsFilters = observer(({ onApply }: BedsAndBathsFiltersProps) => {
  const { compToolStoreV2: compToolStore } = useStore();

  const { compToolFiltersStore } = compToolStore;
  const classes = useStyles();

  const [bathsActive, setBathsActive] = useState(getInitialValue(compToolFiltersStore.form.fields.FULL_BATHS.max.value));
  const [halfBathsActive, setHalfBathsActive] = useState(getInitialValue(compToolFiltersStore.form.fields.HALF_BATHS.max.value));
  const [bedsActive, setBedsActive] = useState(getInitialValue(compToolFiltersStore.form.fields.BEDROOMS.max.value));
  const [roomssActive, setRoomssActive] = useState(getInitialValue(compToolFiltersStore.form.fields.ROOMS.max.value));

  function getInitialValue(value) {
    return value === 20 ? '5+' : value;
  }

  const handleMinMaxButtonClick = (activeButton, value, name, setValue) => {
    setValue(value);
    if (value == '5+') {
      compToolFiltersStore.onFieldsChange(name, 'min', 5);
      compToolFiltersStore.onFieldsChange(name, 'max', 20);
    } else {
      compToolFiltersStore.onFieldsChange(name, 'min', value);
      compToolFiltersStore.onFieldsChange(name, 'max', value);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem" className={classes.root}>
      <ButtonGroupFilter options={roomsOptions} activeButton={roomssActive} setActiveButton={handleMinMaxButtonClick} title='Rooms' name='ROOMS' setValue={setRoomssActive} />
      <Divider variant="fullWidth" />
      <ButtonGroupFilter options={roomsOptions} activeButton={bedsActive} setActiveButton={handleMinMaxButtonClick} title='Beds' name='BEDROOMS' setValue={setBedsActive} />
      <Divider variant="fullWidth" />
      <ButtonGroupFilter options={roomsOptions} activeButton={bathsActive} setActiveButton={handleMinMaxButtonClick} title='Baths' name='FULL_BATHS' setValue={setBathsActive} />
      <Divider variant="fullWidth" />
      <ButtonGroupFilter options={roomsOptions} activeButton={halfBathsActive} setActiveButton={handleMinMaxButtonClick} title='Half-Baths' name='HALF_BATHS' setValue={setHalfBathsActive} />
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="center">
        <Button color="primary" variant="outlined" className={classes.applyButton} onClick={() => onApply && onApply()}>Apply</Button>
      </Box>
    </Box>
  );
});
